<template>
  <div style="padding:5px 0">
    <div class="section operations">
      <div class="triggers">
        <div>
          <el-button v-show="$checkPermission(['button_TabCRMCustomerEvent_add'])" :disabled="!isEditing" type="primary" no="1" @click="showEditDialog(1)">{{ $t('common.btn.new') }}</el-button>
          <el-button v-show="$checkPermission(['button_TabCRMCustomerEvent_edit'])" :disabled="!(isEditing && selectedRow)" type="primary" no="2" @click="showEditDialog(2)">{{ $t('common.btn.edit') }}</el-button>
          <el-button v-show="$checkPermission(['button_TabCRMCustomerEvent_delete'])" :disabled="!isEditing" size="mini" type="danger" no="3" @click="remove">{{ $t('common.btn.delete') }}</el-button>
        </div>
      </div>
    </div>
    <div class="section" style="flex: 1">
      <cargo-ag-grid
        config-module="23150202"
        :grid-params.sync="girdParams"
        :grid-options="gridOptions"
        :column-defs="columnDefs"
        :row-data="finalRowData"
        no="4"
        @gridReady="params=>{gridApi=params.api}"
      />
    </div>
    <!-- 编辑弹窗 -->
    <el-dialog
      v-if="editDialog.visible"
      id="editDialog"
      v-el-drag-dialog
      :visible.sync="editDialog.visible"
      :title="$t('CargoMsg.Cargo_EventRecord')"
      width="600px"
      :close-on-click-modal="false"
      append-to-body
      no="5"
    >
      <div class="app-main-inner-row">
        <el-form label-width="100px" label-position="right">
          <el-form-item :label="$t('CargoMsg.Cargo_theme')" required>
            <el-select
              v-model="editDialog.form.titleName"
              style="width: 100%"
              :disabled="!editDialog.isEdit"
              :placeholder="$t('CargoMsg.Cargo_PleaseSelectP')"
              size="mini"
              no="6"
            >
              <el-option
                v-for="(item,index) in CrmCustomerConstants.CUSTOMER_EVENT_SUBJECTS"
                :key="index"
                :label="$store.getters.language==='zh'?item.chineseName:item.englishName"
                :value="item.code"
              />
            </el-select>
          </el-form-item>
          <el-form-item :label="$t('CargoMsg.Cargo_TaskTime')">
            <el-date-picker
              v-model="editDialog.form.taskTime"
              style="width: 100%"
              type="datetime"
              :clearable="false"
              :picker-options="pickerOptions"
              format="yyyy-MM-dd HH:mm"
              :disabled="!(editDialog.isEdit && editDialog.isEditTime)"
              :editable="false"
              no="7"
            />
          </el-form-item>
          <el-form-item :label="$t('CargoMsg.Cargo_Recorder')">
            <el-input v-model="editDialog.form.recorderName" :disabled="true" style="width: 100%" no="8" />
          </el-form-item>
          <el-form-item :label="$t('CargoMsg.Cargo_RecordTime')">
            <el-date-picker
              v-model="editDialog.form.recordTime"
              type="datetime"
              style="width: 100%"
              format="yyyy-MM-dd HH:mm"
              :disabled="true"
              no="9"
            />
          </el-form-item>
          <el-form-item :label="$t('CargoMsg.Cargo_EventStatus')" required>
            <el-select
              v-model="editDialog.form.status"
              style="width: 100%"
              :disabled="!editDialog.isEdit"
              :placeholder="$t('CargoMsg.Cargo_PleaseSelectP')"
              size="mini"
              no="10"
            >
              <el-option
                v-for="(item,index) in CrmCustomerConstants.CUSTOMER_EVENT_STATUSS"
                :key="index"
                :label="$store.getters.language==='zh'?item.chineseName:item.englishName"
                :value="item.code"
              />
            </el-select>
          </el-form-item>
          <el-form-item :label="$t('CargoMsg.Cargo_Location')">
            <el-input v-model="editDialog.form.address" :disabled="!editDialog.isEdit" no="11" />
          </el-form-item>
          <el-form-item :label="$t('CargoMsg.Cargo_Participant')">
            <el-input v-model="editDialog.form.participants" type="textarea" :rows="3" :disabled="!editDialog.isEdit" no="12" />
          </el-form-item>
          <el-form-item :label="$t('CargoMsg.Cargo_ContentDescription')">
            <el-input v-model="editDialog.form.content" type="textarea" :rows="9" :disabled="!editDialog.isEdit" no="13" />
          </el-form-item>
          <el-form-item :label="$t('CargoMsg.Cargo_Outcomes')">
            <el-input v-model="editDialog.form.achievement" type="textarea" :rows="3" :disabled="!editDialog.isEdit" no="14" />
          </el-form-item>
          <el-form-item :label="$t('CargoMsg.Cargo_NextStep')">
            <el-input v-model="editDialog.form.nextTask" type="textarea" :rows="3" :disabled="!editDialog.isEdit" no="15" />
          </el-form-item>
          <el-form-item :label="$t('CargoMsg.Cargo_ReportTo')">
            <el-input v-model="editDialog.form.reportTarget" type="textarea" :rows="2" :disabled="!editDialog.isEdit" no="16" />
          </el-form-item>
          <el-form-item :label="$t('CargoMsg.Cargo_Remarks')">
            <el-input v-model="editDialog.form.remarks" type="textarea" :rows="3" :disabled="!editDialog.isEdit" no="17" />
          </el-form-item>
          <el-form-item :label="$t('CargoMsg.Cargo_SupervisorComments')">
            <el-input v-model="editDialog.form.supervisorComments" type="textarea" :rows="3" :disabled="!editDialog.isEdit || !editDialog.editSupervisorComments" no="18" />
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer">
        <el-button v-show="editDialog.isEdit" type="primary" no="19" @click="save">{{ $t('CargoMsg.Cargo_Confirm') }}</el-button>
        <el-button no="20" @click="close">{{ $t('CargoMsg.Cargo_Cancel') }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>

import { QuotationClient } from '@/class/model/sales/QuotationClient'
import { getLoading } from '@/utils/utilBaseElement'
import { ensureExecuteSuccess, sleep } from '@/utils/commonUtil'
import * as CrmCustomerConstants from '@/class/cargo/model/parameters/CrmCustomerConstants'
import ColumnUtils from '@/utils/ColumnUtils'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import { getObjectByCache } from '@/utils/basicDataCache'
import { basicCacheKeys } from '@/utils/cacheConfig'

export default {
  name: 'TabCrmCustomerEvent',
  components: {
  },
  props: {
    context: {
      type: Object,
      required: true
    },
    modelType: { type: Number, required: true, default: 1 }, // 模块类型 0.我的客户  1.本组客户  2.客户公海  3.客户回收站
    action: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      CrmCustomerConstants,
      girdParams: {},
      gridOptions: {
        rowSelection: 'multiple',
        suppressCellSelection: true,
        context: {
          componentParent: this
        },
        onRowClicked: this.onRowClicked,
        onRowSelected: this.onRowSelected,
        onRowDoubleClicked: event => { this.onRowDoubleClicked() }
      },
      columnDefs: [
        {
          headerName: '',
          field: '',
          width: 35,
          headerCheckboxSelection: true,
          checkboxSelection: true,
          sortable: false,
          suppressMenu: true,
          suppressSizeToFit: true,
          resizable: false
        },
        {
          headerName: this.$t('CargoMsg.Cargo_EventTime'),
          colId: 'taskTime',
          field: 'taskTime',
          valueFormatter: (params) => {
            if (!params.value) return ''
            return ColumnUtils.dateTimeLabelFunc(params.value)
          },
          tooltip: (params) => {
            return params.valueFormatted
          },
          width: 150
        }, {
          headerName: this.$t('CargoMsg.Cargo_Recorder'),
          colId: 'recorderId',
          field: 'recorderId',
          valueFormatter: (params) => {
            if (!params.value) return ''
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', params.value, 'chineseName')
          },
          tooltip: (params) => {
            return params.valueFormatted
          },
          width: 150
        }, {
          headerName: this.$t('CargoMsg.Cargo_Location'),
          colId: 'address',
          field: 'address',
          valueFormatter: (params) => {
            return params.value
          },
          tooltip: (params) => {
            return params.valueFormatted
          },
          width: 150
        }, {
          headerName: this.$t('CargoMsg.Cargo_Participant'),
          colId: 'participants',
          field: 'participants',
          valueFormatter: (params) => {
            return params.value
          },
          tooltip: (params) => {
            return params.valueFormatted
          },
          width: 150
        }, {
          headerName: this.$t('CargoMsg.Cargo_theme'),
          colId: 'titleName',
          field: 'titleName',
          valueFormatter: (params) => {
            return params.value
          },
          tooltip: (params) => {
            return params.valueFormatted
          },
          width: 150
        }, {
          headerName: this.$t('CargoMsg.Cargo_ContentDescription'),
          colId: 'content',
          field: 'content',
          valueFormatter: (params) => {
            return params.value
          },
          tooltip: (params) => {
            return params.valueFormatted
          },
          width: 150
        }, {
          headerName: this.$t('CargoMsg.Cargo_RecordTime'),
          colId: 'recordTime',
          field: 'recordTime',
          valueFormatter: (params) => {
            if (!params.value) return ''
            return ColumnUtils.dateMinutesLabelFunc(params.value)
          },
          tooltip: (params) => {
            return params.valueFormatted
          },
          width: 150
        }, {
          headerName: this.$t('CargoMsg.Cargo_Remarks'),
          colId: 'remarks',
          field: 'remarks',
          valueFormatter: (params) => {
            return params.value
          },
          tooltip: (params) => {
            return params.valueFormatted
          },
          width: 150
        }, {
          headerName: this.$t('CargoMsg.Cargo_SupervisorComments'),
          colId: 'supervisorComments',
          field: 'supervisorComments',
          valueFormatter: (params) => {
            return params.value
          },
          tooltip: (params) => {
            return params.valueFormatted
          },
          width: 150
        }, {
          headerName: this.$t('CargoMsg.Cargo_EventStatus'),
          colId: 'status',
          field: 'status',
          valueFormatter: (params) => {
            return params.value
          },
          tooltip: (params) => {
            return params.valueFormatted
          },
          width: 150
        }, {
          headerName: this.$t('CargoMsg.Cargo_Outcomes'),
          colId: 'achievement',
          field: 'achievement',
          valueFormatter: (params) => {
            return params.value
          },
          tooltip: (params) => {
            return params.valueFormatted
          },
          width: 150
        }, {
          headerName: this.$t('CargoMsg.Cargo_NextStep'),
          colId: 'nextTask',
          field: 'nextTask',
          valueFormatter: (params) => {
            return params.value
          },
          tooltip: (params) => {
            return params.valueFormatted
          },
          width: 150
        }, {
          headerName: this.$t('CargoMsg.Cargo_ReportTo'),
          colId: 'reportTarget',
          field: 'reportTarget',
          valueFormatter: (params) => {
            return params.value
          },
          tooltip: (params) => {
            return params.valueFormatted
          },
          width: 150
        }
      ],
      gridApi: null,
      rowData: [],
      selectedRow: null, // 当前选中行
      pickerOptions: { // 设置可选时间范围
        disabledDate: this.disabledDate
      },
      editDialog: {
        isEditTime: false, // 是否可以编辑时间
        isEdit: false, // 是否编辑状态
        visible: false,
        editSupervisorComments: false, // 是否可以编辑主管评论
        form: {},
        initialForm: {
          uuid: '',
          taskTime: '',
          recorderId: 0,
          recorderName: '',
          address: '',
          participants: '',
          titleName: '',
          status: '',
          content: '',
          recordTime: '',
          remarks: '',
          supervisorComments: '',
          quotationClientUuid: ''
        }
      },
      quotationClient: new QuotationClient().fillDefaultValue().getData()
    }
  },
  computed: {
    isEditing() {
      return this.action !== 'look'
    },
    finalRowData() {
      return this.rowData.filter(p => !p.deleted)
    }
  },
  created() {
    this.editDialog.form = { ...this.editDialog.initialForm }
  },
  methods: {
    async onShow(row, isRefresh) {
      if (!isRefresh && this.isEditing) return
      this.quotationClient = { ...row }
      this.loading = getLoading()
      if (this.gridApi) {
        await sleep(100)
      } else {
        // 等待gridApi被赋值
        await ensureExecuteSuccess(() => this.gridApi)
      }
      this.selectedRow = null
      this.gridApi.clearFocusedCell()
      if (!this.isEditing || !this.quotationClient.quotationClientEvent || this.quotationClient.quotationClientEvent.length <= 0) {
        this.quotationClient.quotationClientEvent = []
        await new QuotationClient(this.quotationClient).loadQuotationClientRelated({ event: true })
        // this.$logger.log('this.quotationClient==========1', row, row.quotationClientEvent)
      }
      this.rowData = this.quotationClient.quotationClientEvent
      // this.$logger.log('this.quotationClient==========2', this.quotationClient, this.rowData)
      this.loading.close()
    },
    // 保存
    getSubmitData() {
      // this.$logger.log('quotationClientEvent====', this.rowData)
      return {
        quotationClientEvent: this.rowData
      }
    },
    // 行点击
    onRowClicked(event) {
      if (!event || !event.data) return
      this.selectedRow = event.data
    },
    // 行首多选框勾选事件
    onRowSelected(event) {
      if (!event || !event.data) return
      if (event.node.isSelected()) {
        this.onRowClicked(event)
      }
    },
    onRowDoubleClicked() {
      this.showEditDialog(this.isEditing ? 2 : 0)
    },
    // 新增 1 /编辑 2/查看 0
    showEditDialog(state) {
      this.editDialog.isEdit = (state !== 0)
      if (this.editDialog.isEdit) {
        // 我的客户
        if (this.modelType === 0) {
          this.editDialog.editSupervisorComments = this.$checkPermission(['role_TabCRMCustomerEvent_supervisorComments'])
        } else if (this.modelType === 1) {
          // 本组客户
          this.editDialog.editSupervisorComments = this.$checkPermission(['role_CRMMyGroupCustomerManager_supervisorComments'])
        } else {
          this.editDialog.editSupervisorComments = false
        }
      }
      if (state === 1) {
        this.editDialog.isEditTime = true
        this.editDialog.form = { ...this.editDialog.initialForm }
        this.editDialog.form.recorderId = this.$store.getters.userId
        this.editDialog.form.recordTime = new Date()
        this.editDialog.form.taskTime = new Date()
      } else {
        if (!this.gridApi) return
        // 编辑 查看 走这里
        if (!this.selectedRow) {
          this.$message.warning(this.$t('CargoMsg.Cargo_PSAEF'))
          return
        }
        this.editDialog.isEditTime = false
        this.editDialog.form = this.selectedRow
      }
      const user = getObjectByCache(basicCacheKeys.basic_data_User, 'userId', parseInt(this.editDialog.form.recorderId))
      this.editDialog.form.recorderName = this.$store.getters.language === 'zh' ? user.chineseName : user.englishName
      this.editDialog.visible = true
    },
    // 确认保存/修改
    save() {
      if (!this.editDialog.form.titleName) {
        this.$message.warning(this.$t('CargoMsg.Cargo_SelectSubject'))
        return
      }
      if (!this.editDialog.form.status) {
        this.$message.warning(this.$t('CargoMsg.Cargo_SelectEventStatus'))
        return
      }

      // 处理新增
      if (!this.editDialog.form.uuid) {
        const index = this.rowData.indexOf(this.editDialog.form)
        if (index < 0) this.rowData.push(this.editDialog.form)
        setTimeout(() => {
          this.gridApi.setFocusedCell(this.finalRowData.length - 1)
        }, 100)
      } else {
        // 处理编辑
        if (this.rowData && this.rowData.length > 0) {
          for (const contact of this.rowData) {
            if (contact.uuid === this.editDialog.form.uuid) {
              Object.assign(contact, this.editDialog.form)
              contact.updated = true // updated 是否需要更新标识
              break
            }
          }
        }
      }
      this.close()
      this.gridApi.refreshCells({ force: true })
    },
    // 取消
    close() {
      this.editDialog.visible = false
    },
    // 删除【只删除界面值】
    remove() {
      this.$confirm(this.$t('CargoMsg.Cargo_Confirm_Delete'), this.$t('common.tips.confirm'), {
        confirmButtonText: this.$t('common.btn.ok'),
        cancelButtonText: this.$t('common.btn.cancel'),
        type: 'warning'
      }).then(() => {
        this.doRemove()
      })
    },
    doRemove() {
      const rows = this.gridApi.getSelectedRows()
      if (!rows || rows.length <= 0) {
        this.$message.warning(this.$t('common.tips.hasOneAtleast'))
        return
      }
      for (const row of rows) {
        if (row.uuid) { // 数据库里面存在的需要打个标识，数据库不存在的直接移除
          row.deleted = true // deleted 是否需要更新标识
        } else {
          const index = this.rowData.findIndex(p => p === row)
          if (index > -1) {
            this.rowData.splice(index, 1)
          }
        }
      }
      const tempRowData = this.rowData
      this.rowData = []
      this.$nextTick(() => {
        this.rowData = tempRowData
      })
      setTimeout(() => {
        this.gridApi.setFocusedCell(0)
        this.selectedRow = null
        if (this.finalRowData && this.finalRowData.length > 0) {
          this.selectedRow = this.finalRowData[0]
        }
      }, 100)
      this.gridApi.refreshCells({ force: true })
    },
    // 设置不可选日期范围
    disabledDate(currDate) {
      return currDate < new Date()
    }
  }
}
</script>
<style scoped lang="scss">
</style>
